import { Swiper, SwiperSlide } from 'swiper/react';

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";

import  { Pagination } from 'swiper';




export const SliderSection=()=>{
    

    return(
        <div className='__container'>
            <Swiper
                style={{padding:'60px 0px'}}
                slidesPerView={1}
                onSlideChange={() => {}}
                onSwiper={(swiper) => console.log(swiper)}
            
                pagination={{clickable: true }}
                modules={[Pagination]}
                >
                <SwiperSlide style={{width:'1140px'}}>
                    <div className='slider_el'>
                        <div>
                            <img src={require('../../../../static/twitter-bird.png')}/>
                        </div>
                        <div className='slider_author-name'>
                            <a><p>name</p></a><span>/ 35min</span>
                        </div>
                        <div className='slider-body'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut tellus ac nulla semper rhoncus.</p>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide style={{width:'1140px'}}>
                    <div className='slider_el'>
                        <div>
                            <img src={require('../../../../static/twitter-bird.png')}/>
                        </div>
                        <div className='slider_author-name'>
                            <a><p>name</p></a><span>/ 35min</span>
                        </div>
                        <div className='slider-body'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut tellus ac nulla semper rhoncus.</p>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide style={{width:'1140px'}}>
                    <div className='slider_el'>
                        <div>
                            <img src={require('../../../../static/twitter-bird.png')}/>
                        </div>
                        <div className='slider_author-name'>
                            <a><p>name</p></a><span>/ 35min</span>
                        </div>
                        <div className='slider-body'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut tellus ac nulla semper rhoncus.</p>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide style={{width:'1140px'}}>
                    <div className='slider_el'>
                        <div>
                            <img src={require('../../../../static/twitter-bird.png')}/>
                        </div>
                        <div className='slider_author-name'>
                            <a><p>name</p></a><span>/ 35min</span>
                        </div>
                        <div className='slider-body'>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ut tellus ac nulla semper rhoncus.</p>
                        </div>
                    </div>
                </SwiperSlide>
                
            </Swiper>
        </div>

    )
}